import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, query, where, getDocs, addDoc, deleteDoc, doc, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import '../../component/dashboard/dashboard.css';

const months = [
    { value: "01", name: "January" }, { value: "02", name: "February" }, { value: "03", name: "March" },
    { value: "04", name: "April" }, { value: "05", name: "May" }, { value: "06", name: "June" },
    { value: "07", name: "July" }, { value: "08", name: "August" }, { value: "09", name: "September" },
    { value: "10", name: "October" }, { value: "11", name: "November" }, { value: "12", name: "December" }
];
const monthsShort = [
    { value: "01", name: "Jan" }, { value: "02", name: "Feb" }, { value: "03", name: "Mar" },
    { value: "04", name: "Apr" }, { value: "05", name: "May" }, { value: "06", name: "Jun" },
    { value: "07", name: "Jul" }, { value: "08", name: "Aug" }, { value: "09", name: "Sep" },
    { value: "10", name: "Oct" }, { value: "11", name: "Nov" }, { value: "12", name: "Dec" }
];

const currentYear = new Date().getFullYear();
const years = Array.from({length: 10}, (_, i) => currentYear + i - 2);

const allCountries = [
  "Afghanistan", "Albania", "Algeria", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "Canada", "China", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "India", "Indonesia", "Ireland", "Italy", "Japan", "Kuwait", "Malaysia", "Maldives", "Mexico", "Nepal", "Netherlands", "New Zealand", "Norway", "Oman", "Pakistan", "Philippines", "Poland", "Portugal", "Qatar", "Russia", "Saudi Arabia", "Singapore", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sweden", "Switzerland", "Thailand", "Turkey", "UAE", "UK", "USA", "Vietnam"
];

const CLOUD_NAME = "invoice-app";       
const API_KEY = "149469791857382";      
const API_SECRET = "CQJwV5ujAkgYO5BHYKMkGIITbMU"; 

const formatCurrency = (num) => {
    if (num === undefined || num === null || num === '') return '-';
    const val = parseFloat(num);
    if (isNaN(val)) return '-';
    return val.toFixed(2);
};

const formatWeight = (weight) => {
    if (!weight) return '-';
    const val = parseFloat(weight);
    if (isNaN(val)) return '-';
    return Number.isInteger(val) ? `${val.toFixed(1)} KG` : `${val} KG`;
};

const CnUpload = () => {
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    
    const [selectedMonth, setSelectedMonth] = useState(months[new Date().getMonth()].value);
    const [selectedYear, setSelectedYear] = useState(currentYear);
    
    const [reportData, setReportData] = useState([]); 
    const [draftData, setDraftData] = useState([]);  
    
    const [draftDay, setDraftDay] = useState(new Date().getDate().toString()); 
    const [draftMonth, setDraftMonth] = useState(monthsShort[new Date().getMonth()].value);
    const [draftYear, setDraftYear] = useState(currentYear);

    const [newDraft, setNewDraft] = useState({
        country: '', awbNo: '', shipment: 'WPX', service: 'DHL', weight: '', cnFiles: [] 
    });
    
    const [uploadingId, setUploadingId] = useState(null); 
    const [previewData, setPreviewData] = useState(null);

    const [awbSearchQuery, setAwbSearchQuery] = useState('');
    const [awbSearchResults, setAwbSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        const fetchCompanies = async () => {
            try {
                const q = query(collection(db, 'companies')); 
                const snap = await getDocs(q);
                const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                list.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                setCompanies(list);
            } catch (error) { console.error("Error fetching companies:", error); }
        };
        fetchCompanies();
    }, []);

    useEffect(() => {
        if (selectedCompanyId) {
            fetchReportData();
            fetchDrafts();
        } else {
            setReportData([]);
            setDraftData([]);
        }
        // eslint-disable-next-line
    }, [selectedCompanyId, selectedMonth, selectedYear]);

    const fetchReportData = async () => {
        setLoading(true);
        try {
            const q = query(collection(db, 'invoices'), where('companyId', '==', selectedCompanyId));
            const querySnapshot = await getDocs(q);
            const targetYearMonth = `${selectedYear}-${selectedMonth}`;
            let flattenedItems = [];
            querySnapshot.docs.forEach(docSnap => {
                const invoice = docSnap.data();
                const invoiceId = docSnap.id;
                let invoiceMonth = invoice.invoiceYearMonth; 
                if(!invoiceMonth && invoice.invoiceDate) invoiceMonth = invoice.invoiceDate.slice(0, 7);

                if (invoiceMonth === targetYearMonth && invoice.items && Array.isArray(invoice.items)) {
                    invoice.items.forEach(item => {
                        let files = item.cnFiles || [];
                        if (files.length === 0 && item.cnUrl) {
                            files = [{ url: item.cnUrl, name: item.cnFileName || 'File 1', publicId: item.cnPublicId || null }];
                        }
                        flattenedItems.push({
                            uniqueKey: `${invoiceId}_${item.id}`, invoiceId: invoiceId, itemId: item.id, ...item, cnFiles: files
                        });
                    });
                }
            });
            flattenedItems.sort((a, b) => new Date(a.date) - new Date(b.date));
            setReportData(flattenedItems);
        } catch (error) { console.error("Error fetching report:", error); }
        setLoading(false);
    };

    const fetchDrafts = async () => {
        try {
            const q = query(collection(db, 'cn_drafts'), where('companyId', '==', selectedCompanyId));
            const snap = await getDocs(q);
            const drafts = snap.docs.map(doc => {
                const data = doc.data();
                let files = data.cnFiles || [];
                if (files.length === 0 && data.cnUrl) {
                    files = [{ url: data.cnUrl, name: data.cnFileName || 'Draft File', publicId: data.cnPublicId || null }];
                }
                return { id: doc.id, ...data, cnFiles: files };
            });
            drafts.sort((a, b) => new Date(a.date) - new Date(b.date));
            setDraftData(drafts);
        } catch (error) { console.error("Error fetching drafts:", error); }
    };

    const handleGlobalSearch = async (e) => {
        e.preventDefault();
        if (!awbSearchQuery.trim()) {
            alert("Please enter an AWB No. to search.");
            return;
        }
        setIsSearching(true);
        setAwbSearchResults([]);

        try {
            const q = query(collection(db, 'invoices'));
            const querySnapshot = await getDocs(q);
            
            let results = [];
            const searchStr = awbSearchQuery.toLowerCase().trim();

            querySnapshot.forEach((doc) => {
                const invoice = doc.data();
                if (invoice.items && Array.isArray(invoice.items)) {
                    const matchedItems = invoice.items.filter(item => 
                        item.awbNo && item.awbNo.toLowerCase().includes(searchStr)
                    );
                    matchedItems.forEach(item => {
                        let files = item.cnFiles || [];
                        if (files.length === 0 && item.cnUrl) {
                            files = [{ url: item.cnUrl, name: item.cnFileName || 'File 1', publicId: item.cnPublicId || null }];
                        }
                        results.push({
                            ...item,
                            invoiceId: doc.id,
                            exchangeRate: invoice.exchangeRate || 100,
                            companyName: invoice.companyName,
                            cnFiles: files
                        });
                    });
                }
            });
            setAwbSearchResults(results);
        } catch (error) {
            console.error("Search Error:", error);
            alert("Error occurred while searching.");
        }
        setIsSearching(false);
    };

    const generateSignature = async (params) => {
        const sortedKeys = Object.keys(params).sort();
        const stringToSign = sortedKeys.map(key => `${key}=${params[key]}`).join('&') + API_SECRET;
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToSign);
        const hashBuffer = await crypto.subtle.digest('SHA-1', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    };

    const uploadToCloudinary = async (file, awbNo) => {
        const timestamp = Math.round((new Date()).getTime() / 1000);
        const cleanAwb = awbNo ? awbNo.replace(/[^a-zA-Z0-9]/g, "_") : "Unknown";
        const public_id_custom = `${cleanAwb}_${timestamp}`; 

        const params = { timestamp: timestamp, folder: 'cn_uploads', public_id: public_id_custom };
        const signature = await generateSignature(params);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("api_key", API_KEY);
        formData.append("timestamp", timestamp);
        formData.append("folder", 'cn_uploads');
        formData.append("public_id", public_id_custom);
        formData.append("signature", signature);

        const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, { method: "POST", body: formData });
        const resData = await response.json();
        if (resData.error) throw new Error(resData.error.message);
        
        return { url: resData.secure_url, name: file.name, publicId: resData.public_id };
    };

    const deleteFromCloudinary = async (publicId) => {
        if (!publicId) return; 
        const timestamp = Math.round((new Date()).getTime() / 1000);
        const params = { public_id: publicId, timestamp: timestamp };
        const signature = await generateSignature(params);

        const formData = new FormData();
        formData.append("public_id", publicId);
        formData.append("api_key", API_KEY);
        formData.append("timestamp", timestamp);
        formData.append("signature", signature);

        try {
            await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/destroy`, { method: "POST", body: formData });
            await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/raw/destroy`, { method: "POST", body: formData });
        } catch (err) { console.error("Cloudinary delete error:", err); }
    };

    const handleAddNewFile = async (e, row) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!window.confirm(`Upload new file for AWB ${row.awbNo}?`)) return;

        setUploadingId(row.uniqueKey);
        try {
            const uploadedData = await uploadToCloudinary(file, row.awbNo);
            
            const invoiceRef = doc(db, 'invoices', row.invoiceId);
            const invoiceSnap = await getDoc(invoiceRef);
            if (invoiceSnap.exists()) {
                const invoiceData = invoiceSnap.data();
                const updatedItems = invoiceData.items.map(item => {
                    if (item.id === row.itemId) {
                        let existingFiles = item.cnFiles || [];
                        if (existingFiles.length === 0 && item.cnUrl) {
                            existingFiles = [{ url: item.cnUrl, name: item.cnFileName, publicId: item.cnPublicId }];
                        }
                        const newFiles = [...existingFiles, uploadedData];
                        return { ...item, cnFiles: newFiles, cnUrl: newFiles[0].url, cnFileName: newFiles[0].name, cnPublicId: newFiles[0].publicId };
                    }
                    return item;
                });
                await updateDoc(invoiceRef, { items: updatedItems });
                await fetchReportData(); 
            }
        } catch (error) { console.error(error); alert("Upload Failed: " + error.message); }
        setUploadingId(null);
    };

    const handleReuploadFromModal = async (e) => {
        const file = e.target.files[0];
        if (!file || !previewData) return;
        
        const { row, file: oldFile, index } = previewData;
        if (!window.confirm("This will DELETE the current file and REPLACE it with the new one. Continue?")) return;

        setUploadingId('modal_reupload'); 
        try {
            const uploadedData = await uploadToCloudinary(file, row.awbNo);
            if (oldFile.publicId) await deleteFromCloudinary(oldFile.publicId);
            
            const invoiceRef = doc(db, 'invoices', row.invoiceId);
            const invoiceSnap = await getDoc(invoiceRef);
            if (invoiceSnap.exists()) {
                const invoiceData = invoiceSnap.data();
                const updatedItems = invoiceData.items.map(item => {
                    if (item.id === row.itemId) {
                        let existingFiles = item.cnFiles || [];
                        existingFiles[index] = uploadedData;
                        const firstFile = existingFiles[0];
                        return { 
                            ...item, 
                            cnFiles: existingFiles, 
                            cnUrl: firstFile.url, 
                            cnFileName: firstFile.name, 
                            cnPublicId: firstFile.publicId 
                        };
                    }
                    return item;
                });
                await updateDoc(invoiceRef, { items: updatedItems });
                await fetchReportData(); 
                setPreviewData({ ...previewData, file: uploadedData });
                alert("File replaced successfully!");
            }
        } catch (err) { console.error(err); alert("Re-upload failed: " + err.message); }
        setUploadingId(null);
    };

    const handleDeleteFromModal = async () => {
        if (!previewData) return;
        const { row, file, index } = previewData;
        if (!window.confirm("Permanently delete this file?")) return;

        try {
            const invoiceRef = doc(db, 'invoices', row.invoiceId);
            const invoiceSnap = await getDoc(invoiceRef);
            if (invoiceSnap.exists()) {
                const invoiceData = invoiceSnap.data();
                const updatedItems = invoiceData.items.map(item => {
                    if (item.id === row.itemId) {
                        let existingFiles = item.cnFiles || [];
                        if (file.publicId) deleteFromCloudinary(file.publicId);
                        const newFiles = existingFiles.filter((_, idx) => idx !== index);
                        const firstFile = newFiles.length > 0 ? newFiles[0] : { url: '', name: '', publicId: null };
                        return { ...item, cnFiles: newFiles, cnUrl: firstFile.url, cnFileName: firstFile.name, cnPublicId: firstFile.publicId };
                    }
                    return item;
                });
                await updateDoc(invoiceRef, { items: updatedItems });
                await fetchReportData();
                closePreview(); 
            }
        } catch (error) { console.error(error); alert("Error deleting file."); }
    };

    const handleDraftFileUpload = async (e) => {
        const file = e.target.files[0];
        if(!file) return;
        setUploadingId('draft');
        try {
            const uploadedData = await uploadToCloudinary(file, newDraft.awbNo || 'Draft');
            setNewDraft(prev => ({ ...prev, cnFiles: [...prev.cnFiles, uploadedData] }));
        } catch(err) { alert("Draft Upload Failed: " + err.message); }
        setUploadingId(null);
    };

    const removeDraftFile = (index) => {
        const fileToDelete = newDraft.cnFiles[index];
        if(fileToDelete.publicId) deleteFromCloudinary(fileToDelete.publicId);
        setNewDraft(prev => ({ ...prev, cnFiles: prev.cnFiles.filter((_, i) => i !== index) }));
    };

    const handleAddDraft = async (e) => {
        e.preventDefault();
        if (!selectedCompanyId) { alert("Select a company first!"); return; }
        
        const monthName = monthsShort.find(m => m.value === draftMonth)?.name || 'Jan';
        const formattedDay = String(draftDay || '01').padStart(2, '0');
        const formattedYear = draftYear || currentYear;
        const finalDateString = `${formattedDay} ${monthName} ${formattedYear}`;

        setLoading(true);
        try {
            const firstFile = newDraft.cnFiles.length > 0 ? newDraft.cnFiles[0] : { url: '', name: '', publicId: null };
            
            const draftObj = {
                companyId: selectedCompanyId,
                companyName: companies.find(c => c.id === selectedCompanyId)?.name,
                date: finalDateString,
                ...newDraft,
                cnUrl: firstFile.url, cnFileName: firstFile.name, cnPublicId: firstFile.publicId,
                createdAt: serverTimestamp()
            };
            await addDoc(collection(db, 'cn_drafts'), draftObj);
            setNewDraft({ country: '', awbNo: '', shipment: 'WPX', service: 'DHL', weight: '', cnFiles: [] });
            fetchDrafts();
            alert("Draft Added!");
        } catch (error) { console.error(error); alert("Error adding draft: " + error.message); }
        setLoading(false);
    };

    const handleDeleteDraft = async (draft) => {
        if (!window.confirm("Delete this draft?")) return;
        try {
            if (draft.cnFiles && draft.cnFiles.length > 0) {
                for (const file of draft.cnFiles) { if (file.publicId) await deleteFromCloudinary(file.publicId); }
            } else if (draft.cnPublicId) { await deleteFromCloudinary(draft.cnPublicId); }
            await deleteDoc(doc(db, 'cn_drafts', draft.id));
            fetchDrafts();
        } catch (error) { console.error(error); }
    };

    const handlePreview = (file, row, index) => {
        if(!file.url) return;
        const isPdf = file.url.toLowerCase().includes('.pdf') || (file.name && file.name.toLowerCase().includes('.pdf'));
        setPreviewData({ file, type: isPdf ? 'pdf' : 'image', row, index });
    };

    const getDownloadUrl = (url) => {
        if (!url) return '#';
        return url.replace('/upload/', '/upload/fl_attachment/');
    };

    const closePreview = () => setPreviewData(null);

    const filteredCountries = allCountries.filter(country => country.toLowerCase().startsWith(newDraft.country.toLowerCase()));

    return (
        <div className="cn-upload-wrapper">
            {previewData && (
                <div className="modal-overlay" onClick={closePreview}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <button className="modal-close-btn" onClick={closePreview}>X</button>
                        <h3>{previewData.file.name}</h3>
                        <div className="cn-preview-box">
                            {previewData.type === 'pdf' ? (
                                 <iframe src={previewData.file.url} title="CN PDF Preview"></iframe> 
                             ) : (
                                 <img src={previewData.file.url} alt="CN Preview" /> 
                             )}
                        </div>
                        <div className="modal-actions-bar">
                            <a href={getDownloadUrl(previewData.file.url)} className="modal-action-btn download-btn" target="_blank" rel="noreferrer">
                                  Download
                            </a>
                            <label className="modal-action-btn reupload-btn">
                                {uploadingId === 'modal_reupload' ? '  Uploading...' : '  Re-upload'}
                                <input type="file" onChange={handleReuploadFromModal} className="hidden-file-input" disabled={uploadingId === 'modal_reupload'} />
                            </label>
                            <button onClick={handleDeleteFromModal} className="modal-action-btn delete-btn-modal">
                                  Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <h2 className="new-invoice-heading">CN Upload & Draft Management</h2>

            <div className="form-section">
                <div className="form-grid" style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div>
                        <label>Select Month</label>
                        <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
                            {months.map(m => <option key={m.value} value={m.value}>{m.name}</option>)}
                        </select>
                    </div>
                    <div>
                        <label>Select Year</label>
                        <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div>
                        <label>Select Company</label>
                        <select value={selectedCompanyId} onChange={e => setSelectedCompanyId(e.target.value)}>
                            <option value="">-- Select Company --</option>
                            {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>

            {selectedCompanyId && (
                <>
                    <div className="form-section" style={{borderTop: '4px solid #f39c12'}}>
                        <h3 style={{color: '#f39c12'}}>Create New Draft Entry</h3>
                        <form onSubmit={handleAddDraft}>
                            <div className="form-grid">
                                <div>
                                    <label>Date (Day / Month / Year)</label>
                                    <div className='date-inputs-group'>
                                        <input placeholder='Day' type='number' value={draftDay} onChange={e => setDraftDay(e.target.value)} required onWheel={(e) => e.target.blur()} />
                                        <select value={draftMonth} onChange={e => setDraftMonth(e.target.value)}>
                                            {monthsShort.map(m => <option key={m.value} value={m.value}>{m.name}</option>)}
                                        </select>
                                        <input placeholder='Year' type='number' value={draftYear} onChange={e => setDraftYear(e.target.value)} onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>
                                
                                <div><label>Country</label><input value={newDraft.country} onChange={e => setNewDraft({...newDraft, country: e.target.value})} placeholder="Type..." required list="cn-country-list" /><datalist id="cn-country-list">{filteredCountries.map(c => <option key={c} value={c} />)}</datalist></div>
                                <div><label>AWB No.</label><input value={newDraft.awbNo} onChange={e => setNewDraft({...newDraft, awbNo: e.target.value})} placeholder="AWB" required /></div>
                                <div><label>Shipment</label><input value={newDraft.shipment} onChange={e => setNewDraft({...newDraft, shipment: e.target.value})} placeholder="WPX" /></div>
                                
                                <div>
                                    <label>Service</label>
                                    <input value={newDraft.service} onChange={e => setNewDraft({...newDraft, service: e.target.value})} placeholder="DHL" list="service-list" />
                                    <datalist id="service-list">
                                        <option value="DHL" />
                                        <option value="FedEx" />
                                        <option value="UPS" />
                                        <option value="Aramex" />
                                    </datalist>
                                </div>
                                <div><label>Weight</label><input type="number" value={newDraft.weight} onChange={e => setNewDraft({...newDraft, weight: e.target.value})} placeholder="KG" required onWheel={(e) => e.target.blur()} /></div>
                            </div>
                            
                            <div className="draft-files-container">
                                <label className="draft-section-label">CN Files</label>
                                <label className="upload-drop-zone">
                                    <div className="text">{uploadingId === 'draft' ? 'Uploading...' : 'Click to Upload CN File'}</div>
                                    <input type="file" onChange={handleDraftFileUpload} className="hidden-file-input" disabled={uploadingId === 'draft'} />
                                </label>
                                {newDraft.cnFiles.length > 0 && (
                                    <div className="draft-files-grid" style={{marginTop: '15px'}}>
                                        {newDraft.cnFiles.map((file, idx) => (
                                            <div key={idx} className="draft-file-card">
                                                <div className="draft-file-info">
                                                    <span className="draft-file-name" title={file.name}>{file.name}</span>
                                                </div>
                                                <button type="button" className="draft-file-remove" onClick={() => removeDraftFile(idx)}>X</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            <button type="submit" disabled={loading} className="add-btn" style={{background: '#f39c12', width: '100%', marginTop: '20px'}}>
                                {loading ? 'Saving...' : 'Save to Drafts'}
                            </button>
                        </form>
                    </div>

                    {draftData.length > 0 && (
                        <div className="form-section">
                            <h3 style={{color: '#e67e22'}}>Pending Drafts ({draftData.length})</h3>
                            <div className="invoice-preview-table full-width-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Country</th>
                                            <th>AWB No.</th>
                                            <th>Shipment</th>
                                            <th>Service</th>
                                            <th>Weight</th>
                                            <th>Files</th>
                                            <th style={{width: '100px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {draftData.map(draft => (
                                            <tr key={draft.id}>
                                                <td>{draft.date}</td>
                                                <td>{draft.country}</td>
                                                <td>{draft.awbNo}</td>
                                                <td>{draft.shipment}</td>
                                                <td>{draft.service}</td>
                                                <td>{formatWeight(draft.weight)}</td>
                                                <td>{draft.cnFiles?.length || 0} Files</td>
                                                <td>
                                                    <div className="action-buttons">
                                                        <button onClick={() => handleDeleteDraft(draft)} className="medium-delete-btn">Delete</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    <div className="form-section">
                        <h3 style={{color: '#2980b9'}}>Existing Invoice Data ({months.find(m => m.value === selectedMonth)?.name} {selectedYear})</h3>
                        <div className="invoice-preview-table full-width-table spacious-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Country</th>
                                        <th>AWB No.</th>
                                        <th>Service</th>
                                        <th>Weight</th>
                                        <th style={{width: '20%'}}>View Files</th>
                                        <th style={{width: '15%'}}>Upload</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.map(row => (
                                        <tr key={row.uniqueKey}>
                                            <td>{row.date}</td>
                                            <td>{row.country}</td>
                                            <td>{row.awbNo}</td>
                                            <td>{row.service}</td>
                                            <td>{formatWeight(row.weight)}</td>
                                            <td>
                                                <div className="file-list-links">
                                                    {row.cnFiles.length > 0 ? (
                                                        row.cnFiles.map((file, idx) => (
                                                            <button 
                                                                key={idx} 
                                                                className="file-view-btn" 
                                                                onClick={() => handlePreview(file, row, idx)}
                                                                title="Click to View/Edit"
                                                            >
                                                                View
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <span className="no-file-text">No Files</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <label className="table-upload-btn">
                                                    {uploadingId === row.uniqueKey ? '...' : 'Upload'}
                                                    <input type="file" onChange={(e) => handleAddNewFile(e, row)} className="hidden-file-input" disabled={uploadingId === row.uniqueKey} />
                                                </label>
                                            </td>
                                        </tr>
                                    ))}
                                    {reportData.length === 0 && <tr><td colSpan="7" style={{padding: '30px', textAlign: 'center'}}>No data found for this month.</td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}

            <div className="form-section" style={{marginTop: '40px', borderTop: '4px solid #333'}}>
                <h3 style={{color: '#333'}}>AWB NO. Search</h3>
                <form onSubmit={handleGlobalSearch} style={{marginBottom: '20px', display: 'flex', gap: '10px'}}>
                    <input 
                        type="text" 
                        value={awbSearchQuery} 
                        onChange={(e) => setAwbSearchQuery(e.target.value)} 
                        placeholder="Enter AWB No. to search..." 
                        style={{flexGrow: 1, padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '4px'}}
                    />
                    <button type="submit" disabled={isSearching} className="add-btn" style={{marginTop: 0, width: '150px'}}>
                        {isSearching ? 'Searching...' : 'Search'}
                    </button>
                </form>

                {awbSearchResults.length > 0 ? (
                    <div className="invoice-preview-table full-width-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>DATE</th>
                                    <th>COUNTRY</th>
                                    <th>AWB NO.</th>
                                    <th>BUYER</th>
                                    <th>SHIPMENT</th>
                                    <th>SERVICE</th>
                                    <th>WEIGHT</th>
                                    <th>RATE</th>
                                    <th>DEMAND ($)</th>
                                    <th>FSC ($)</th>
                                    <th>TOTAL ($)</th>
                                    <th>TOTAL (BDT)</th>
                                    <th>View Files</th>
                                </tr>
                            </thead>
                            <tbody>
                                {awbSearchResults.map((item, idx) => {
                                    const rate = parseFloat(item.rate || 0);
                                    const fsc = parseFloat(item.fsc || 0);
                                    const demand = parseFloat(item.demandCharge || 0);
                                    const exchangeRate = parseFloat(item.exchangeRate || 100);
                                    
                                    // --- BDT LOGIC ADDED HERE ---
                                    let totalUsd = 0;
                                    if (item.rateCurrency === 'BDT') {
                                        const weight = parseFloat(item.weight || 0);
                                        totalUsd = (rate * weight) / exchangeRate;
                                    } else {
                                        totalUsd = rate + fsc + demand;
                                    }
                                    const totalBdt = totalUsd * exchangeRate;

                                    return (
                                        <tr key={idx}>
                                            <td>{item.date || '-'}</td>
                                            <td>{item.country || '-'}</td>
                                            <td>{item.awbNo || '-'}</td>
                                            <td>{item.buyerName || '-'}</td>
                                            <td>{item.shipment || '-'}</td>
                                            <td>{item.service || '-'}</td>
                                            <td>{formatWeight(item.weight)}</td>
                                            
                                            <td>{item.rateCurrency === 'BDT' ? '৳' : '$'} {formatCurrency(rate)}</td>
                                            <td>{formatCurrency(demand)}</td>
                                            <td>{formatCurrency(fsc)}</td>
                                            <td style={{fontWeight: 'bold'}}>{formatCurrency(totalUsd)}</td>
                                            <td style={{fontWeight: 'bold', color: 'green'}}>{formatCurrency(totalBdt)}</td>
                                            
                                            <td>
                                                <div className="file-list-links">
                                                    {item.cnFiles && item.cnFiles.length > 0 ? (
                                                        item.cnFiles.map((file, fIdx) => (
                                                            <button 
                                                                key={fIdx} 
                                                                className="file-view-btn" 
                                                                onClick={() => handlePreview(file, item, fIdx)}
                                                                title="Click to View"
                                                            >
                                                                View
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <span className="no-file-text">No Files</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    awbSearchQuery && !isSearching && <p style={{color: '#777'}}>No results found for "{awbSearchQuery}"</p>
                )}
            </div>
        </div>
    );
};

export default CnUpload;